import React from 'react';

// styles
import { Logo as LogoPage, StyleLogo } from '../Home/style';
import { Obrigado, H2, Cupom, Container, PObrigado } from './style';

// images
import ImageLogo from '../../../assets/images/logo.png';

const Header = () => {
  return (
    <>
      <Container>
        <LogoPage>
          <StyleLogo
            src={ImageLogo}
            alt={'Fábrica do Livro'}
            title={'Fábrica do Livro'}
          />
        </LogoPage>
        <Obrigado>
          <H2>Você ganhou o dobro de</H2>
          <H2>desconto!</H2>
          <PObrigado>
            Agora sim! Seu <strong> desconto em dobro</strong> já está liberado
          </PObrigado>
          <p>para sua primeira compra:</p>
          <Cupom>
            <h1>FDLDEZOFF</h1>
          </Cupom>
        </Obrigado>
      </Container>
    </>
  );
};

export default Header;
